import React from "react";

export const IconOption4 = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.62207 0.523926C4.62207 1.54379 4.62207 4.39915 4.62207 5.62296C4.62207 9.80417 8.31738 11.4358 10.333 11.4358C12.3486 11.4358 16.0439 9.80417 16.0439 5.62296C16.0439 4.39915 16.0439 1.54379 16.0439 0.523926H4.62207ZM10.3438 2.40454L7.8079 3.51198V7.17545L7.80607 7.90201C7.7865 7.89785 6.04737 7.52582 6.04737 4.98568C6.04737 3.93769 6.04737 2.3964 6.04737 2.3964H8.29383L10.3438 2.40454Z"
        fill="#F2F2F2"
      />
      <path
        d="M12.5457 15.431L11.6606 14.1946L11.2182 12.3726L10.3331 12.5027L9.44806 12.3726L9.00554 14.1946L8.44873 14.9726L8.12061 15.422H8.127L8.12061 15.431H12.5457Z"
        fill="#F2F2F2"
      />
      <path
        d="M14.4603 16.6041V16.5952H6.20654V19.5564V19.5625V19.5714H14.4603V16.6102V16.6041Z"
        fill="#F2F2F2"
      />
      <path
        d="M19.8433 4.12011C19.842 4.07294 19.8407 4.03321 19.8407 4.00203V2.20166H17.0919V3.64273H18.3996V4.00203C18.3996 4.04396 18.401 4.09716 18.4028 4.16044C18.4173 4.68038 18.4513 5.89805 17.6013 6.77216C17.4108 6.96807 17.1839 7.13626 16.9235 7.27859C16.7791 7.93466 16.5474 8.52726 16.25 9.05739C17.2381 8.81907 18.0367 8.39154 18.6345 7.77681C19.9089 6.46632 19.8612 4.76185 19.8433 4.12011Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.06487 6.77216C2.21487 5.89805 2.24888 4.68038 2.2635 4.16044C2.26525 4.09716 2.26655 4.04396 2.26655 4.00203V3.64273H3.56275H3.56536H3.57429V2.20166H0.825477V4.00203C0.825477 4.03321 0.824286 4.07294 0.822947 4.12011C0.805016 4.76185 0.757471 6.46632 2.0318 7.77685C2.62957 8.39158 3.42804 8.81903 4.41618 9.05743C4.11871 8.52729 3.88716 7.93459 3.7427 7.27856C3.48232 7.13618 3.25539 6.96807 3.06487 6.77216Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
